import { useState } from "react";
import { NavLink } from "react-router-dom";
import SearchBar from "../components/SearchBar";
import FilterPanel from "../components/FilterPanel";
import JobCard from "../components/JobCard";
import Pagination from "../components/Pagination";
import Navbar from '../components/Navbar';
import "./JobSearch.css";


const mockJobs = [
  {
    id: 1,
    title: "React Developer",
    company: "TechCorp",
    location: "Bangalore",
    experience: 3,
    jobType: "Full-Time",
    jobCategory: "IT",
    workMode: "Hybrid",
    postedDate: "7d",
    companyType: "MNC",
  },
  {
    id: 2,
    title: "UI/UX Designer",
    company: "DesignLabs",
    location: "Mumbai",
    experience: 1,
    jobType: "Remote",
    jobCategory: "Design",
    workMode: "Remote",
    postedDate: "24h",
    companyType: "Startup",
  },
  {
    id: 3,
    title: "Backend Engineer",
    company: "CodeWorks",
    location: "Delhi",
    experience: 7,
    jobType: "Full-Time",
    jobCategory: "IT",
    workMode: "On-site",
    postedDate: "30d",
    companyType: "MNC",
  },
  {
    id: 4,
    title: "Data Analyst",
    company: "DataPro",
    location: "Bangalore",
    experience: 4,
    jobType: "Part-Time",
    jobCategory: "Analytics",
    workMode: "Hybrid",
    postedDate: "7d",
    companyType: "Government",
  },
  {
    id: 5,
    title: "Frontend Developer",
    company: "WebSolutions",
    location: "Hyderabad",
    experience: 3,
    jobType: "Remote",
    jobCategory: "IT",
    workMode: "Remote",
    postedDate: "24h",
    companyType: "Startup",
  },
  {
    id: 6,
    title: "Product Manager",
    company: "InnovateTech",
    location: "Chennai",
    experience: 8,
    jobType: "Full-Time",
    jobCategory: "Management",
    workMode: "On-site",
    postedDate: "30d",
    companyType: "MNC",
  },
];

function JobSearch() {
  const [jobs, setJobs] = useState(mockJobs);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const jobsPerPage = 6;  
  const totalPages = Math.ceil(jobs.length / jobsPerPage);

  const handleSearch = (keyword) => {
    setLoading(true);
    setError(null);
    try {
      const filteredJobs = mockJobs.filter((job) =>
        job.title.toLowerCase().includes(keyword.toLowerCase()) ||
        job.company.toLowerCase().includes(keyword.toLowerCase())
      );
      setJobs(filteredJobs);
      setCurrentPage(1);
    } catch (err) {
      setError("Failed to fetch jobs. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleFilter = (filters) => {
    setLoading(true);
    setError(null);
    try {
      const filteredJobs = mockJobs.filter((job) => {
        return (
          (filters.location === "" || job.location === filters.location) &&
          (!filters.experience ||
            (filters.experience === "Fresher" && job.experience === 0) ||
            (filters.experience !== "Fresher" &&
              job.experience >= parseInt(filters.experience.split("-")[0]) &&
              job.experience <=
                (filters.experience === "10+"
                  ? Infinity
                  : parseInt(filters.experience.split("-")[1])))) &&
          (filters.jobType.length === 0 || filters.jobType.includes(job.jobType)) &&
          (filters.workMode.length === 0 || filters.workMode.includes(job.workMode)) &&
          (filters.jobCategory.length === 0 ||
            filters.jobCategory.includes(job.jobCategory)) &&
          (!filters.postedDate || job.postedDate === filters.postedDate) &&
          (filters.companyType.length === 0 ||
            filters.companyType.includes(job.companyType))
        );
      });
      setJobs(filteredJobs);
      setCurrentPage(1);
    } catch (err) {
      setError("Failed to apply filters. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const paginatedJobs = jobs.slice(
    (currentPage - 1) * jobsPerPage,
    currentPage * jobsPerPage
  );

  return (
    <div className="job-search-container">
      <Navbar />
      
      <h1 className="job-search-heading">Find Jobs</h1>
      <SearchBar onSearch={handleSearch} />
      <div className="job-search-content">
        <FilterPanel onFilter={handleFilter} />
        <div className="job-listings-wrapper">
          {loading && <div className="job-search-loading-spinner">Loading...</div>}
          {error && <div className="job-search-error-message">{error}</div>}
          <div className="job-search-listings">
            {paginatedJobs.length > 0 ? (
              paginatedJobs.map((job) => <JobCard key={job.id} job={job} />)
            ) : (
              <p className="job-search-no-jobs">
                No jobs found. Try adjusting your search or filters.
              </p>
            )}
          </div>
          {paginatedJobs.length > 0 && (
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={setCurrentPage}
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default JobSearch;